import { render, staticRenderFns } from "./OffRoad.vue?vue&type=template&id=366941f1&scoped=true"
import script from "./OffRoad.vue?vue&type=script&lang=js"
export * from "./OffRoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366941f1",
  null
  
)

export default component.exports